import React from 'react';
import { Spin } from 'antd';
import { connect } from 'dva';

function SSOLogin(): React.ReactElement {
  return (
    <div
      style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Spin />
    </div>
  );
}

const ConnectedSSOLogin: React.ComponentType = connect((state: { sso: unknown }) => ({
  sso: state.sso,
}))(SSOLogin);
export default ConnectedSSOLogin;
